module.exports = __webpack_public_path__ + "static/media/down-arrow-svgrepo-com.5bba49f8.svg";